/*
 * 6 For 60 Page
 */

import LazyHelper from '../helpers/lazy-helper';

export default class SixForSixty {
    constructor() {
        this.filterEl = document.querySelector('.js-flavor-filter');
        this.filtersContainer = this.filterEl.querySelector('.flavor-filter__filters-container');
        this.filters = this.filterEl.querySelectorAll('.flavor-filter__item');
        this.sections = this.filterEl.querySelectorAll('.flavor-filter__section');
        this.resetButton = this.filterEl.querySelector('.flavor-filter__back');

        this.filterFromUrl();
        this.initListeners();
    }

    initListeners() {
        document.addEventListener('click', (event) => {
            // function to check if clicked element is inside another element
            const is = (selector) => event.target.closest(selector);

            if (is('.flavor-filter__item')) {
                event.preventDefault();
                this.updateFilter(event.target.closest('.flavor-filter__item'));
                LazyHelper.showLazies();
            }

            if (is('.flavor-filter__back')) {
                event.preventDefault();
                this.resetFilter();
            }

            if (is('.recipe-box__see-more')) {
                event.preventDefault();
                const recipe = event.target.closest('.recipe-box');
                const instructions = recipe.querySelector('.recipe-box__instructions');
                const button = recipe.querySelector('.recipe-box__see-more');
                if (instructions) instructions.classList.add('show');
                if (button) button.classList.add('hide');
            }
        });
    }

    updateFilter(target) {
        this.resetFilter();
        this.filterEl.classList.add('is-engaged');
        this.filtersContainer.classList.add('md-up-only');

        const targetItem = target.closest('.flavor-filter__item');
        targetItem.classList.add('active');

        const targetId = target.closest('.flavor-filter__item').href.split('#')[1];
        const resultsEl = document.getElementById(targetId);
        resultsEl.classList.add('active');

        this.resetButton.classList.add('md-down-only', 'show');

        // Set browser URL/history state based on new filter
        const { pathname } = window.location;
        const { title } = document;
        let newTitle = title.split('|');
        newTitle.splice(1, 0, `- ${target.innerText.trim()} Recipes `);
        newTitle.splice(2, 0, '|');
        newTitle = newTitle.join('');

        // Turns out browsers don't support changing the title, but leaving it here.
        // https://github.com/whatwg/html/issues/2174
        window.history.pushState({}, newTitle, `${pathname}#${targetId}`);
    }

    resetFilter() {
        this.filterEl.classList.remove('is-engaged');
        this.filtersContainer.classList.remove('md-up-only');

        const activeFilter = document.querySelector('.flavor-filter__item.active');
        if (activeFilter) activeFilter.classList.remove('active');

        const activeSection = document.querySelector('.flavor-filter__section.active');
        if (activeSection) activeSection.classList.remove('active');

        this.resetButton.classList.remove('md-down-only', 'show');
    }

    filterFromUrl() {
        const { hash } = window.location;

        const matchingFilterElement = this.filterEl.querySelector(`.flavor-filter__item[href="${hash}"]`);

        if (matchingFilterElement) {
            this.updateFilter(matchingFilterElement);
        }
    }
}
